// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"recent-blog-posts_wrapper__3T5LB","hidden":"recent-blog-posts_hidden__3x4dP","animated":"recent-blog-posts_animated__3gNTk"};